var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90.1856058px",
    height: "72.8753492px",
    viewBox: "0 0 90.1856058 72.8753492",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres---Logo-et-CGU",
    transform: "translate(-344.564394, -530.624651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(338.000000, 513.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 100 0 100 100 0 100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1666667,75 C18.3406304,75 9.56439394,66.6053391 9.56439394,56.25 C9.56439394,45.8946609 18.3406304,37.5 29.1666667,37.5 C30.820674,30.1313972 36.7169318,24.1166896 44.6343769,21.7215594 C52.5518219,19.3264291 61.2876059,20.9147535 67.5510435,25.888226 C73.8144812,30.8616986 76.6540074,38.4647305 75,45.8333333 L79.1666667,45.8333333 C87.2208191,45.8333335 93.7499997,52.3625142 93.7499997,60.4166667 C93.7499997,68.4708191 87.2208191,75 79.1666667,75 L75,75",
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "37.5 62.5 50 50 62.5 62.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 50,
    y2: 87.5,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadColor);
export default __webpack_public_path__ + "static/media/icon_upload_color.5743322bbf6ef6f8c7b1260ac4d87ed4.svg";
export { ForwardRef as ReactComponent };